export default async function getForm(id, runtime = false, signal = null) {
  return await (
    await fetch(
      `${
        runtime
          ? process.env.NEXT_PUBLIC_DRUPAL_RUNTIME_BASE_URL
          : process.env.NEXT_PUBLIC_DRUPAL_BASE_URL
      }/webform_rest/${id}/fields`,
      {
        method: "GET",
        signal: signal,
      }
    )
  ).json();
}
